import { CompatibleProductId } from '@atlassian/mpac-types';
export const productInfoMap = {
  [CompatibleProductId.Jira]: {
    banner: {
      breadcrumbTitle: 'Jira',
      heading: 'Explore apps for Jira',
      description: 'Elevate your experience with customizable apps to fit any use case'
    },
    showEnterpriseAppsSection: true
  },
  [CompatibleProductId.Confluence]: {
    banner: {
      breadcrumbTitle: 'Confluence',
      heading: 'Explore apps for Confluence',
      description: 'Enhance content collaboration with apps to customize for your team’s needs'
    },
    showEnterpriseAppsSection: true
  },
  [CompatibleProductId.JiraServiceManagement]: {
    banner: {
      breadcrumbTitle: 'Jira Service Management',
      heading: 'Explore apps for Jira Service Management',
      description: 'Provide exceptional service with best suited apps to boost your business'
    },
    showEnterpriseAppsSection: true
  },
  [CompatibleProductId.Fisheye]: {
    banner: {
      breadcrumbTitle: 'Fisheye',
      heading: 'Explore apps for Fisheye',
      description: 'Leverage apps to effectively illustrate and expedite your coding modifications'
    }
  },
  [CompatibleProductId.Crucible]: {
    banner: {
      breadcrumbTitle: 'Crucible',
      heading: 'Explore apps for Crucible',
      description: 'Find apps that boost collaborative code assessment and efficient knowledge exchange'
    }
  },
  [CompatibleProductId.Bitbucket]: {
    banner: {
      breadcrumbTitle: 'Bitbucket',
      heading: 'Explore apps for Bitbucket',
      description: 'Expand capabilities and streamline your code collaboration methods with apps'
    }
  },
  [CompatibleProductId.Bamboo]: {
    banner: {
      breadcrumbTitle: 'Bamboo',
      heading: 'Explore apps for Bamboo',
      description: 'Unleash the power of agile development with apps, from code to deployment'
    }
  },
  [CompatibleProductId.Crowd]: {
    banner: {
      breadcrumbTitle: 'Crowd',
      heading: 'Explore apps for Crowd',
      description: 'Optimize identity management with dynamic user control and authentication apps'
    }
  },
  [CompatibleProductId.COMPASS]: {
    banner: {
      breadcrumbTitle: 'Compass',
      heading: 'Explore apps for Compass',
      description: 'Customize and build new capabilities to create an efficient developer experience'
    }
  }
};